import React, { lazy, Suspense } from 'react';
import { Show, ErrorNamespaceProvider, BlockingErrorBoundary, TrackingFunnelProvider } from '@edreamsodigeo/frontend-core';
const Funnel = /*#__PURE__*/lazy(() => import(/* webpackChunkName: "invfunnel" */
/* webpackPrefetch: true */
'./Funnel'));
const invoicesRegex = /\/travel\/invoices\//;
export const InvoicesFunnel = () => {
  return /*#__PURE__*/React.createElement(ErrorNamespaceProvider, {
    namespace: "bookingAdmin"
  }, /*#__PURE__*/React.createElement(BlockingErrorBoundary, {
    name: "funnel_invoices"
  }, /*#__PURE__*/React.createElement(Show, {
    when: invoicesRegex.test(window.location.href)
  }, /*#__PURE__*/React.createElement(TrackingFunnelProvider, {
    funnel: "invoices"
  }, /*#__PURE__*/React.createElement(Suspense, {
    fallback: null
  }, /*#__PURE__*/React.createElement(Funnel, null))))));
};